import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { ApplicationState } from "../../../store";
import * as httpClient from "../../../util/httpClient";
import { Notification } from "../../common/Notification";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const ManageAccountSecurity = () => {
    const { register, handleSubmit, errors } = useForm({
        mode: "onTouched",
        criteriaMode: "all",
    });
    const { t: tLang } = useTranslation();
    const [showEdit, setShowEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const securityQuestionAnswer = [
        { label: tLang("manageAccount.myAccount.manageAccountSecurity.label.securityQuestion") + " 1", que: 0 },
        { label: tLang("manageAccount.myAccount.manageAccountSecurity.label.securityQuestion") + " 2", que: 1 },
        { label: tLang("manageAccount.myAccount.manageAccountSecurity.label.securityQuestion") + " 3", que: 2 },
    ];
    const [state, setState] = useState<any>([]);
    const accountInfo = useSelector((state: ApplicationState) => (state && state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    let userData = useSelector((state: ApplicationState) => {
        let data: any = {
            email: "",
            isIDFUser: false,
            isSuccess: true,
            securityQuestionsCount: 3,
            portalName: "",
            isLanguageSupport: "true"
        };
        if (state.configurationState && state.configurationState.configuration && state.configurationState.configuration.partnerConfig != null) {
            data.portalName = state.configurationState.configuration.partnerConfig.partnerProvider;
        }

        if (accountInfo && accountInfo.email) {
            data.email = accountInfo.email;
        }
        if (state.csidUserStatusState && state.csidUserStatusState.csidUserStatus) {
            data.isIDFUser = state.csidUserStatusState.csidUserStatus.isIDFUser;
        }

        return data;
    });

    const [securityQue, setSecurityQue] = useState<any>([]);

    const showEditForm = () => {
        setShowEdit(true);
    };

    const hideEditForm = () => {
        setShowEdit(false);
    };

    const handleQusSelect = (qusId: any, index: any) => {
        let newSeqQus = securityQue.map((qus: any) => {
            let newQus = qus;

            if (qus.selectedIndex === index) {
                newQus = { ...qus };
                delete newQus.selected;
                delete newQus.selectedIndex;
            }
            if (qus.id === parseInt(qusId)) {
                newQus = { ...qus };
                newQus["selected"] = true;
                newQus["selectedIndex"] = index;
            }
            return newQus;
        });
        setSecurityQue(newSeqQus);
    };

    const onSubmit = (data: any) => {
        setIsLoading(true);

        data.item.forEach((item: any) => {
            item.Id = parseInt(item.Id);
            const selectedQuestion: any = securityQue.filter((que: any) => item.Id === que.id)[0];
            item.question = selectedQuestion.question;
        });
        let reqBody = {
            securityQuestionAnswer: data.item,
            portalName: userData.portalName,
        };

        httpClient
            .sendRequest("POST", "api/security-question/save-security-questions", reqBody)
            .then((res) => {
                if (!res.isSuccess) {
                    setIsLoading(false);
                } else {
                    getQuestions();
                    Notification({
                        type: "success",
                        title: tLang("manageAccount.myAccount.manageAccountSecurity.nontification.successTitle"),
                        message: tLang("manageAccount.myAccount.manageAccountSecurity.nontification.successMsg"),
                    });
                }
            })
            .catch((err) => {
                setIsLoading(false);
                Notification({
                    type: "error",
                    title: "Error",
                    message: err,
                    duration: 0,
                });
            });
    };

    const renderSecurityQuestions = (item: { label: string; que: number }, index: number) => {
        let defaultVal = securityQue && securityQue.length && securityQue.find((val: any) => val.selectedIndex === index);
        const answerIndex = "answer" + (index + 1);

        return (
            <React.Fragment key={index}>
                <div className="form-row inline row">
                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                        <legend className="legend-label" id={`label-security-question-${index}`}> <label htmlFor={`select-security-question-${index}`}>
                            {" "}
                            {item.label}
                       </label> </legend>
                    </div>

                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                        <select
                            className="inputbox"
                            id={`select-security-question-${index}`}
                            name={`item[${index}].Id`}
                            ref={register({ required: true })}
                            defaultValue={defaultVal ? defaultVal.id : ""}
                            onChange={(e) => handleQusSelect(e.target.value, index)}
                        >
                            <option value="">--- {tLang("manageAccount.myAccount.manageAccountSecurity.defaultOption")} ---</option>
                            {securityQue &&
                                securityQue.length > 0 &&
                                securityQue.map((val: any) => {
                                    return (
                                        <option key={val.id} value={val.id} disabled={val.selected && val.selectedIndex !== index}>
                                            {val.question}
                                        </option>
                                    );
                                })}
                        </select>
                        {errors &&
                            errors["item"] &&
                            errors["item"][index] &&
                            errors["item"][index]["Id"] &&
                            errors["item"][index]["Id"].types &&
                            errors["item"][index]["Id"].types.required === true && (
                                <span className="form-error">
                                    <p>{tLang("manageAccount.myAccount.manageAccountSecurity.validation.qusRequired")}</p>
                                </span>
                            )}
                    </div>
                </div>

                <div className="form-row inline row">
                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                        <legend className="legend-label" id={`label-security-question-${index}`}> <label htmlFor={`label-security-question-${index}-answer`}>
                            {tLang("manageAccount.myAccount.manageAccountSecurity.label.answer")}<span className="hide-label">{index + 1}</span>
                       </label> </legend>
                    </div>

                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                        <input
                            type="text"
                            className={errors[answerIndex] ? "status-error inputbox" : "inputbox"}
                            name={`item[${index}].answer`}
                            id={`label-security-question-${index}-answer`}
                            ref={register({
                                required: true,
                                minLength: 4,
                            })}
                        />
                        {errors["item"] &&
                            errors["item"][index] &&
                            errors["item"][index]["answer"] &&
                            errors["item"][index]["answer"].types &&
                            errors["item"][index]["answer"].types.required === true && (
                                <span className="form-error">
                                    <p>{tLang("manageAccount.myAccount.manageAccountSecurity.validation.ansRequired")}</p>
                                </span>
                            )}
                        {errors["item"] &&
                            errors["item"][index] &&
                            errors["item"][index]["answer"] &&
                            errors["item"][index]["answer"].types &&
                            errors["item"][index]["answer"].types.minLength && (
                                <span className="form-error">
                                    <p>{tLang("manageAccount.myAccount.manageAccountSecurity.validation.minLength")}</p>
                                </span>
                            )}
                    </div>
                </div>
            </React.Fragment>
        );
    };

    const getQuestions = () => {
        httpClient
            .sendRequest("POST", "api/security-question/get-security-questions", userData)
            .then((data) => {
                setState(data);
                if (data && data.securityQuestionList.length) {
                    let secQus = data.securityQuestionList.map((qus: any) => {
                        if (data.selectedSecurityQuestion) {
                            let index = data.selectedSecurityQuestion.findIndex((v: any) => qus.id === v.id);
                            if (index !== -1) {
                                let newQus = { ...qus };
                                newQus["selected"] = true;
                                newQus["selectedIndex"] = index;
                                return newQus;
                            }
                            return qus;
                        } else {
                            return qus;
                        }
                    });
                    setSecurityQue(secQus);
                }
                setIsLoading(false);
                setShowEdit(false);
            })
            .catch((err) => {
                setIsLoading(false);
                setShowEdit(false);
            });
    };
    useEffect(() => {
        getQuestions();
    }, []);

    return (
        <React.Fragment>
            <div className={isLoading ? "box offset-padding loading" : "box offset-padding"}>
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon" aria-hidden="true">
                            <RenderIcons iconName="question" />
                        </div>
                        <div className="box-title-text has-actions">
                            <h2 className="box-title">{tLang("manageAccount.myAccount.manageAccountSecurity.title")}</h2>
                        </div>
                    </div>
                    {!showEdit && (
                        <div className="box-actions">
                            <button type="button" className="btn-default btn-grey-dot" id="security-questions" onClick={showEditForm}>
                                <span className="btn-text">
                                    {tLang("manageAccount.myAccount.manageAccountSecurity.editButtonText")}{" "}
                                    <span className="sr-only">{tLang("manageAccount.myAccount.manageAccountSecurity.label.securityQuestion")}</span>
                                </span>
                                <span className="btn-icon">
                                    <RenderIcons iconName="pen" />
                                </span>
                            </button>
                        </div>
                    )}
                </div>
                <div className="box-content">
                    {!showEdit && (
                        <div role="grid" className="data-grid" id="security-questions-grid" aria-hidden="false">
                            {state.selectedSecurityQuestion &&
                                state.selectedSecurityQuestion.map((val: string, i: number) => (
                                    <div role="row" className="data-row row" key={`sq-${i}`}>
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`label-password-security-question${i}`}>
                                                {tLang("manageAccount.myAccount.manageAccountSecurity.label.securityQuestion")} {i + 1}
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={`label-password-security-question${i}`}>
                                                {val.question}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    )}
                    {showEdit && (
                        <div id="security-questions-form" aria-hidden="false">
                            <form id="security-questions-form-container" onSubmit={handleSubmit(onSubmit)}>
                                {securityQuestionAnswer.map((val, index) => renderSecurityQuestions(val, index))}
                                <div className="margin-vertical-l"></div>
                                <div className="row between-xs">
                                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <ul className="list-inline list-reset">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-link btn-no-padding btn-no-border btn-min-width"
                                                    onClick={() => hideEditForm()}
                                                >
                                                    <span className="btn-text">{tLang("manageAccount.myAccount.manageAccountSecurity.cancelButtonText")}</span>
                                                </button>
                                            </li>
                                            <li className="margin-left-s">
                                                <button type="submit" className="btn-default btn-primary btn-min-width">
                                                    <span className="btn-text">{tLang("manageAccount.myAccount.manageAccountSecurity.saveButtonText")}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default ManageAccountSecurity;
